import {
    forwardMeetingPersonaPrefix,
    forwardMeetingOnBehalfOfText,
} from './MeetingForwardSenderPersona.locstring.json';
import loc from 'owa-localize';
import SenderPersona from './SenderPersona';
import { observer } from 'mobx-react-lite';
import Message from 'owa-service/lib/contract/Message';
import MessageSafetyLevel from 'owa-service/lib/contract/MessageSafetyLevel';

import * as React from 'react';

const styles = require('./SenderPersona.scss');
const classNames = require('classnames');

export interface MeetingForwardSenderPersonaProps {
    message: Message;
    senderPersonaClassName?: string;
}

const MeetingForwardSenderPersona = observer(function MeetingForwardSenderPersona(
    props: MeetingForwardSenderPersonaProps
) {
    const { message, senderPersonaClassName } = props;
    const messageSafetyLevel = message.MessageSafety
        ? message.MessageSafety.MessageSafetyLevel
        : MessageSafetyLevel.None;
    return (
        <span>
            <span className={classNames(styles.meetingForwardSenderLineText)}>
                {loc(forwardMeetingPersonaPrefix)}
            </span>
            <SenderPersona
                sender={null}
                isRead={true}
                treatAsDraft={false}
                displaySelf={true}
                hideSMTP={false}
                messageSafetyLevel={messageSafetyLevel}
                isUnauthenticatedSender={message.AntispamUnauthenticatedSender}
                className={senderPersonaClassName}
            />
            <span className={classNames(styles.meetingForwardSenderLineText)}>
                {loc(forwardMeetingOnBehalfOfText)}
            </span>
            <SenderPersona
                sender={message.From}
                isRead={true}
                treatAsDraft={false}
                displaySelf={false}
                hideSMTP={false}
                messageSafetyLevel={messageSafetyLevel}
                isUnauthenticatedSender={message.AntispamUnauthenticatedSender}
                className={senderPersonaClassName}
            />
        </span>
    );
});
export default MeetingForwardSenderPersona;
